import { render, staticRenderFns } from "./PortalSettings.vue?vue&type=template&id=4acc78aa&scoped=true"
import script from "./PortalSettings.vue?vue&type=script&lang=js"
export * from "./PortalSettings.vue?vue&type=script&lang=js"
import style0 from "./PortalSettings.vue?vue&type=style&index=0&id=4acc78aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acc78aa",
  null
  
)

export default component.exports